import Immutable, { fromJS } from 'immutable';
import { get } from 'lodash-es';

import * as types from './actionTypes';

import { locale } from '../Tools/reducers';
import * as systemTypes from '../System/actionTypes';

import { getCommercialProductList } from './transform';

let newState;
let newCommercialProducts;
let newCommercialProduct;

const products = (state, action) => {
  try {
    switch (action.type) {
      // LOCALE
      case systemTypes.FETCH_USER_LANGUAGE: {
        return state.set('strings', locale(action?.data?.language, 'products'));
      }

      // FETCH PRODUCTS V2
      case types.FETCH_COMMERCIAL_PRODUCTS_V2_REQUEST:
        newState = state.mergeDeep(state, Immutable.fromJS({ loading: { isLoadingProductsV2: true } }));
        return newState;

      case types.FETCH_COMMERCIAL_PRODUCTS_V2_SUCCESS:
        newCommercialProducts = Immutable.fromJS(action.data);
        newState = state.setIn(['commercialproductsV2'], fromJS(newCommercialProducts));
        newState = newState.setIn(['list'], fromJS(getCommercialProductList(action.data)));
        newState = newState.setIn(['loading', 'isLoadingProductsV2'], false);
        return newState;

      case types.FETCH_COMMERCIAL_PRODUCTS_V2_FAIL:
        newState = state.mergeDeep(state, Immutable.fromJS({ isLoadingProductsV2: false }));
        newState = newState.setIn(['alerts'], fromJS(action.error));
        return newState;

      // FETCH PRODUCT
      case types.FETCH_COMMERCIAL_PRODUCT_REQUEST: {
        newState = state.setIn(['loading', 'isLoadingProduct'], true);
        return newState;
      }

      case types.FETCH_COMMERCIAL_PRODUCT_SUCCESS: {
        // set/update product in store
        newCommercialProduct = fromJS(get(action.data, '[0]', {}));
        newCommercialProduct = state.getIn(['products', String(action.id)])
          ? newCommercialProduct.mergeDeep(state.getIn(['products', String(action.id)]))
          : newCommercialProduct;
        newState = state.setIn(['products', String(action.id)], newCommercialProduct);
        newState = newState.setIn(['loading', 'isLoadingProduct'], false);
        return newState;
      }

      case types.FETCH_COMMERCIAL_PRODUCT_FAIL: {
        newState = state.setIn(['products', String(action.id)], undefined);
        newState = newState.setIn(['loading', 'isLoadingProduct'], false);
        newState = newState.setIn(['alerts', 'errors'], fromJS(action.error));
        return newState;
      }

      default:
        return state;
    }
  } catch (e) {
    console.log(e.stack);
    return state;
  }
};
export default products;
